import React, { useState, useEffect } from "react";
// components
import {
  Grid,
  Divider,
  Button,
  TextField,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Slider,
  Tooltip,
  RadioGroup,
  FormControlLabel,
  Radio,
  Backdrop,
  CircularProgress,
} from "@material-ui/core";
import DateFnsUtils from "@date-io/date-fns"; // choose your lib
import {
  DatePicker,
  TimePicker,
  DateTimePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import L from "leaflet";
import { polylineMeasure } from "leaflet.polylinemeasure"; //do not Remove
import InputHeader from "../../components/pagesCommonComponents/InputHeader";
import DropDown from "../../components/pagesCommonComponents/DropDown";
import "leaflet.fullscreen";
import "leaflet.coordinates/dist/Leaflet.Coordinates-0.1.5.min";
import "leaflet.coordinates/dist/Leaflet.Coordinates-0.1.5.css";
import "font-awesome/css/font-awesome.min.css";
import "leaflet.locatecontrol/dist/L.Control.Locate.min.css";
import "leaflet.locatecontrol/dist/L.Control.Locate.min.js";

//icons
// import { ImLocation2 } from "react-icons/im";
// import { CgErase } from "react-icons/cg";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import markerIcon from "../../images/markerIcon.png";

// style
import useStyle from "./styles";

function ValueLabelComponent(props) {
  const { children, open, value } = props;

  return (
    <Tooltip open={open} enterTouchDelay={0} placement="top" title={value}>
      {children}
    </Tooltip>
  );
}

// ValueLabelComponent.propTypes = {
//   children: PropTypes.element.isRequired,
//   open: PropTypes.bool.isRequired,
//   value: PropTypes.number.isRequired,
// };

function Sar() {
  const classes = useStyle();
  const [mapCenter, setMapCenter] = useState([24.17, 60.06]);
  const [lat, setLat] = useState("");
  const [lng, setLng] = useState("");
  const [objectClassOptions, setObjectClassOptions] = useState([
    { title: "Person-in-water (PIW), unknown state (mean value" },
    { title: "PIW, vertical" },
    { title: "PIW, sitting" },
    { title: "PIW, horizontal, survival suit" },
    { title: "PIW, horizontal, scuba suit" },
    { title: "PIW, horizontal, deceased" },
    { title: "Life-raft, no ballast (NB) system, general (mean values)" },
    { title: "Life-raft, no ballast system, no canopy, no drogue" },
  ]);
  const [oceanographicOptions, setOceanographicOptions] = useState([
    { title: "MFS MyOcean" },
  ]);
  const [depthOptions, setDepthOptions] = useState([
    { title: "1.5m (surface)" },
    { title: "4.6m" },
    { title: "7.1m" },
    { title: "9.6m" },
    { title: "10.5m" },
    { title: "12.7m" },
    { title: "18.9m" },
    { title: "21.5m" },
    { title: "23.2m" },
    { title: "25.7m" },
    { title: "27.8m" },
  ]);
  const [weatherOptions, setWeatherOptionsOptions] = useState([
    { title: "ECMWF" },
  ]);

  const [backdropOpen, setBackdropOpen] = useState(false);
  const backdropClose = () => {
    setBackdropOpen(false);
  };
  const polygons = [
    [
      { lat: 25.533148, lng: 57.097321 },
      { lat: 25.556695, lng: 7.085648 },
      { lat: 25.569698, lng: 57.110367 },
      { lat: 25.559787, lng: 57.129593 },
      { lat: 25.553593, lng: 57.13028 },
      { lat: 25.541202, lng: 57.11792 },
      { lat: 25.531289, lng: 57.110367 },
    ],

    [
      { lat: 25.388698, lng: 57.116547 },
      { lat: 25.398623, lng: 57.108307 },
      { lat: 25.396142, lng: 57.064362 },
      { lat: 25.371328, lng: 57.056122 },
      { lat: 25.345267, lng: 57.064362 },
      { lat: 25.315477, lng: 57.098694 },
      { lat: 25.324167, lng: 57.128906 },
      { lat: 25.347749, lng: 57.142639 },
      { lat: 25.373809, lng: 57.150879 },
    ],

    [
      { lat: 24.784241, lng: 57.623291 },
      { lat: 24.816654, lng: 57.584839 },
      { lat: 24.864011, lng: 57.609558 },
      { lat: 24.873978, lng: 57.650757 },
      { lat: 24.844073, lng: 57.669983 },
      { lat: 24.806681, lng: 57.669983 },
      { lat: 24.794215, lng: 57.667236 },
    ],

    [
      { lat: 25.334717, lng: 57.583466 },
      { lat: 25.344026, lng: 57.582436 },
      { lat: 25.345267, lng: 57.587929 },
      { lat: 25.345267, lng: 57.594109 },
      { lat: 25.340613, lng: 57.598915 },
      { lat: 25.333476, lng: 57.596512 },
      { lat: 25.332545, lng: 57.593422 },
      { lat: 25.332545, lng: 57.589645 },
      { lat: 25.332545, lng: 57.587585 },
    ],

    [
      { lat: 25.08933, lng: 57.950134 },
      { lat: 25.120419, lng: 57.944641 },
      { lat: 25.125393, lng: 57.959747 },
      { lat: 25.121663, lng: 57.983093 },
      { lat: 25.10301, lng: 57.99408 },
      { lat: 25.086843, lng: 57.98172 },
      { lat: 25.074405, lng: 57.966614 },
    ],

    [
      { lat: 25.107984, lng: 58.41156 },
      { lat: 25.160201, lng: 58.433533 },
      { lat: 25.160201, lng: 58.496704 },
      { lat: 25.140312, lng: 58.51593 },
      { lat: 25.105497, lng: 58.50769 },
      { lat: 25.073161, lng: 58.471985 },
      { lat: 25.065697, lng: 58.436279 },
    ],

    [
      { lat: 25.020907, lng: 58.859253 },
      { lat: 25.040815, lng: 58.905945 },
      { lat: 25.01344, lng: 58.919678 },
      { lat: 24.993526, lng: 58.922424 },
      { lat: 24.95618, lng: 58.922424 },
      { lat: 24.946219, lng: 58.894958 },
      { lat: 24.948709, lng: 58.842773 },
      { lat: 24.97112, lng: 58.820801 },
      { lat: 25.01344, lng: 58.829041 },
    ],

    [
      { lat: 24.542126, lng: 59.655762 },
      { lat: 24.567108, lng: 59.606323 },
      { lat: 24.61456, lng: 59.633789 },
      { lat: 24.61456, lng: 59.677734 },
      { lat: 24.607069, lng: 59.694214 },
      { lat: 24.584593, lng: 59.694214 },
      { lat: 24.569606, lng: 59.694214 },
      { lat: 24.554618, lng: 59.688721 },
    ],

    [
      { lat: 24.961783, lng: 60.170403 },
      { lat: 24.977033, lng: 60.174522 },
      { lat: 24.980768, lng: 60.192719 },
      { lat: 24.967074, lng: 60.201988 },
      { lat: 24.96116, lng: 60.200615 },
      { lat: 24.955869, lng: 60.189285 },
      { lat: 24.954312, lng: 60.179329 },
      { lat: 24.955869, lng: 60.171776 },
    ],
  ];

  useEffect(() => {
    window.sarMap = L.map("sarMap", {
      zoomControl: false,
      // fullscreenControl: true,
    }).setView(mapCenter, 7);
    L.control.zoom({ position: "bottomright" }).addTo(window.sarMap);
    L.tileLayer("http://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png").addTo(
      window.sarMap,
    );

    var mbUrl =
      "https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token=pk.eyJ1IjoibWFwYm94IiwiYSI6ImNpejY4NXVycTA2emYycXBndHRqcmZ3N3gifQ.rJcFIG214AriISLbB6B5aw";

    var dark = L.tileLayer(mbUrl, {
        id: "mapbox/dark-v10",
        tileSize: 512,
        zoomOffset: -1,
      }),
      streets = L.tileLayer(mbUrl, {
        id: "mapbox/streets-v11",
        tileSize: 512,
        zoomOffset: -1,
      }),
      satellite = L.tileLayer(mbUrl, {
        id: "mapbox/satellite-v9",
        tileSize: 512,
        zoomOffset: -1,
      }),
      light = L.tileLayer(mbUrl, {
        id: "mapbox/light-v10",
        tileSize: 512,
        zoomOffset: -1,
      });

    var baseLayers = {
      Streets: streets,
      Dark: dark,
      Light: light,
      satellite: satellite,
    };

    L.control.layers(baseLayers).addTo(window.sarMap);

    let options = {
      position: "topleft",
      clearMeasurementsOnStop: true,
      showBearings: false,
      showClearControl: true,
      showUnitControl: true,
      distanceShowSameUnit: true,
    };

    L.control.polylineMeasure(options).addTo(window.sarMap);

    L.control
      .coordinates({
        position: "bottomleft",
        decimals: 6,
        decimalSeperator: ",",
        labelTemplateLat: "Latitude: {y}",
        labelTemplateLng: "Longitude: {x}",
      })
      .addTo(window.sarMap);
    var lc = L.control
      .locate({
        position: "topright",
        strings: {
          title: "Show Your Location",
        },
      })
      .addTo(window.sarMap);

    window.sarMap.on("click", function (e) {
      setLat(e.latlng.lat);
      setLng(e.latlng.lng);
    });
    return () => {};
  }, []);

  useEffect(() => {
    if (lng && lat) {
      if (window.marker) {
        window.sarMap.removeLayer(window.marker);
        window.marker = null;
      }
      let icon = L.icon({
        iconUrl: markerIcon,
        iconSize: [38, 48],
        iconAnchor: [22, 43],
        popupAnchor: [-3, -76],
      });
      window.marker = L.marker({ lat: lat, lng: lng }, { icon: icon }).addTo(
        window.sarMap,
      );
    }
  }, [lat, lng]);
  return (
    <div className={classes.mainContainer}>
      <div className={classes.optionContainer}>
        <div className={classes.formContainer}>
          <Accordion defaultExpanded>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <Typography className={classes.accordionHeading}>
                SIMULATION INPUT &nbsp;
                {/* <ImLocation2 size="1.2rem" /> */}
              </Typography>
            </AccordionSummary>
            <AccordionDetails className={classes.accordionDetails}>
              <InputHeader
                title="GENERAL"
                info='In "General", the user should enter the "Simulation name" used to identify a given simulation by a unique name. In "Object class", the user should choose an object class from a given category of objects. If the specific object class is not known or is not in the list, the user should choose a category from the list with similar floating characteristics to the object being searched for.'
              />
              <TextField
                variant="outlined"
                label="Simulation name"
                placeholder="Enter simulation name"
                // infoerText="Full width!"
                fullWidth
                margin="normal"
                size="small"
                InputLabelProps={{
                  shrink: true,
                }}
              />
              <DropDown label="Object Class" options={objectClassOptions} />
              <InputHeader
                title="LAST KNOWN POSITION"
                info="The last known position is defined as the location in longitude and latitude of an object where it was last seen or thought to have been located at the time of an accident."
              />
              <Grid container direction="row">
                <Grid item container direction="column" xs>
                  {/* <Grid item>
                    <span>Lat</span>
                    <input type="text" className={classes.coordinatesInput} />
                  </Grid>
                  <Grid item>
                    <span>Long</span>
                    <input type="text" className={classes.coordinatesInput} />
                  </Grid> */}
                  <Grid item>
                    <TextField
                      variant="outlined"
                      label="Latitude"
                      value={lat}
                      onChange={(e) => setLat(e.target.value)}
                      size="small"
                      style={{ width: 100 }}
                      className={classes.coordinatesInput}
                    />
                  </Grid>
                  <Grid item>
                    <TextField
                      variant="outlined"
                      label="Longitude"
                      value={lng}
                      onChange={(e) => setLng(e.target.value)}
                      margin="dense"
                      size="small"
                      style={{ width: 100 }}
                      className={classes.coordinatesInput}
                    />
                  </Grid>
                </Grid>
                <Grid item xs>
                  <TextField
                    variant="outlined"
                    label="Radius(KM)"
                    size="small"
                    style={{ width: 100 }}
                    className={classes.coordinatesInput}
                  />
                </Grid>
              </Grid>
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <DateTimePicker
                  inputVariant="outlined"
                  size="small"
                  margin="normal"
                  label="Start of drifter release"
                />
              </MuiPickersUtilsProvider>
              <InputHeader
                title="SIMULATION DURATION (HOURS)"
                info="The user should choose a simulation time (in hours). The simulation time is calculated from the initial time of drifters release to the time of the final position of the drifters."
              />
              <Slider
                ValueLabelComponent={ValueLabelComponent}
                aria-label="custom thumb label"
                defaultValue={20}
                min={1}
                max={276}
              />

              <InputHeader
                title="FORECASTING SYSTEM"
                info="The current version of OCEAN-SAR DSS includes the following forecasting system for surface and subsurface currents: MyOcean hourly data at a resolution of about 6 x 6 km. The MyOcean forecasting system covers the spatial domain within the Mediterranean Sea (25.2°N-53.3°N, 10°W-43.9°E).The 10 m winds are taken from the ECMWF system which provides a wind forecast every three and six hours at a resolution of 25 x 25 km. Future versions will include the choice of other high-resolution forecasting systems."
              />
              <DropDown
                label="Oceanographic forecasting system"
                options={oceanographicOptions}
              />
              <br />
              <DropDown label="Depth of currents" options={depthOptions} />
              <br />

              <DropDown
                label="Weather forecasting system"
                options={weatherOptions}
              />

              {/* <InputHeader
                title="DISPLAY"
                info="Select or deselect the first checkbox to display or hide environmental fields on the map . Select or deselect the second checkbox to display or hide the ruler on the map"
              /> */}
            </AccordionDetails>
          </Accordion>

          <Accordion>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel2a-content"
              id="panel2a-header"
            >
              <Typography className={classes.accordionHeading}>
                COMPUTED SIMULATIONS
                {/* <CgErase size="1.5rem" /> */}
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography>no simulation</Typography>
            </AccordionDetails>
          </Accordion>
        </div>
        <div className={classes.submitContainer}>
          <Divider variant="middle" />
          <br />
          <Grid container justify="flex-end">
            <Button
              variant="outlined"
              color="primary"
              onClick={() => {
                setBackdropOpen(true);
                setTimeout(() => {
                  let polygon =
                    polygons[Math.floor(Math.random() * (8 - 1 + 1)) + 1];
                  L.polygon(polygon).addTo(window.sarMap);
                  setBackdropOpen(false);
                  window.sarMap.flyTo(polygon[0], 11, { animate: true });
                }, 2000);
              }}
            >
              Submit
            </Button>
            <Backdrop className={classes.backdrop} open={backdropOpen}>
              <CircularProgress color="inherit" />
            </Backdrop>
          </Grid>
        </div>
      </div>
      <div className={classes.mapContainer}>
        <div id="sarMap" className={classes.map}></div>
      </div>
    </div>
  );
}

export default Sar;
